import { TableCard } from 'app/components'
import { UsuariosListHeader } from './components/header/UsuariosListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { UsuariosTable } from './table/UsuariosTable'

const UsuariosList = () => {
  return (
    <TableCard>
      <UsuariosListHeader />
      <UsuariosTable />
    </TableCard>
  )
}

export const UsuariosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <UsuariosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
